import { extractRoleTokens, PSDA_ADMIN_ORGANIZATION_TYPE_ID } from "@utils/psdaAdminAccess";

export const TEVTA_ORGANIZATION_TYPE_ID = 7;
export const PVTC_ORGANIZATION_TYPE_ID = 8;

export const EVENT_ENTITY_PBTE = "pbte";
export const EVENT_ENTITY_TEVTA = "tevta";
export const EVENT_ENTITY_PVTC = "pvtc";
export const EVENT_ENTITY_PSDA = "psda";

export type EventEntity =
	| typeof EVENT_ENTITY_PBTE
	| typeof EVENT_ENTITY_TEVTA
	| typeof EVENT_ENTITY_PVTC
	| typeof EVENT_ENTITY_PSDA;

const normalizeToken = (value: string): string =>
	value.trim().toLowerCase().replace(/-/g, "_").replace(/\s+/g, "_");

export function resolveEventEntity(options: {
	organizationTypeId?: number | null;
	roles?: unknown[];
	userTypeName?: string | null;
}): EventEntity | null {
	const organizationTypeId = Number(options.organizationTypeId);
	const tokens = [
		...extractRoleTokens(options.roles).map(normalizeToken),
		options.userTypeName ? normalizeToken(options.userTypeName) : "",
	].filter(Boolean);

	const includesToken = (keyword: string) => tokens.some(token => typeof token === "string" && token.includes(keyword));

	if (organizationTypeId === TEVTA_ORGANIZATION_TYPE_ID || includesToken("tevta")) {
		return EVENT_ENTITY_TEVTA;
	}

	if (organizationTypeId === PVTC_ORGANIZATION_TYPE_ID || includesToken("pvtc")) {
		return EVENT_ENTITY_PVTC;
	}

	if (includesToken("pbte_admin") || includesToken("pbte")) {
		return EVENT_ENTITY_PBTE;
	}

	if (organizationTypeId === PSDA_ADMIN_ORGANIZATION_TYPE_ID || includesToken("psda")) {
		return EVENT_ENTITY_PSDA;
	}

	return null;
}

/** Authority code for pending-endorsement API filter (matches backend `authorityCode`). */
export function getAuthorityCodeForEntity(entity: EventEntity | null): string | undefined {
	switch (entity) {
		case EVENT_ENTITY_TEVTA:
			return "TEVTA";
		case EVENT_ENTITY_PVTC:
			return "PVTC";
		case EVENT_ENTITY_PBTE:
			return "PBTE";
		case EVENT_ENTITY_PSDA:
			return undefined;
		default:
			return undefined;
	}
}
